var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    viewBox: "0 -960 960 960",
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.231-120v-430.769H120v-176.924h205.692q-11.923-10.538-16.5-25.004-4.577-14.467-4.577-30.38 0-39.744 27.821-67.564 27.82-27.821 67.564-27.821 23 0 42.231 10.808t33.154 28.115q13.923-17.538 33.154-28.231 19.23-10.692 42.23-10.692 39.744 0 67.564 27.821 27.821 27.82 27.821 67.564 0 15.615-4.692 30.115-4.693 14.5-16.385 25.269H840v176.924h-49.231V-120H169.231Zm381.538-718.462q-23.538 0-39.461 15.923-15.923 15.924-15.923 39.462 0 23.538 15.923 39.461 15.923 15.923 39.461 15.923 23.539 0 39.462-15.923 15.923-15.923 15.923-39.461 0-23.538-15.923-39.462-15.923-15.923-39.462-15.923Zm-206.154 55.385q0 23.538 15.924 39.461 15.923 15.923 39.461 15.923 23.538 0 39.461-15.923 15.924-15.923 15.924-39.461 0-23.538-15.924-39.462-15.923-15.923-39.461-15.923-23.538 0-39.461 15.923-15.924 15.924-15.924 39.462ZM160-687.692v96.923h300v-96.923H160ZM460-160v-390.769H209.231V-160H460Zm40 0h250.769v-390.769H500V-160Zm300-430.769v-96.923H500v96.923h300Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGiftIcon);
export default __webpack_public_path__ + "static/media/send-gift-icon.05a720f93cd1d98db2784cb1a0564723.svg";
export { ForwardRef as ReactComponent };